module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "logo-login"
  }, [(_vm.entity.name == 'amigo') ? _c('img', {
    attrs: {
      "src": require("../assets/logo-login/amigo.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'amicitia') ? _c('img', {
    staticClass: "amicitia-logo-login",
    attrs: {
      "src": require("../assets/logo-login/amicitia.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'hannick') ? _c('img', {
    staticClass: "hannick-logo-login",
    attrs: {
      "src": require("../assets/logo-login/hannick.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'friendshipcruises') ? _c('img', {
    staticClass: "friendshipcruises-logo-login",
    attrs: {
      "src": require("../assets/logo-login/friendshipcruises.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'davincitravel') ? _c('img', {
    attrs: {
      "src": require("../assets/logo/davincitravel.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'aircruise') ? _c('img', {
    attrs: {
      "src": require("../assets/logo/aircruise.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'ncrv-reizen') ? _c('img', {
    attrs: {
      "src": require("../assets/logo-login/ncrv-reizen.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'agro') ? _c('img', {
    attrs: {
      "src": require("../assets/logo-login/agro.png"),
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card paper card-login"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-alerts"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [(_vm.usernameInvalid) ? _c('li', [_vm._v("Email is verkeerd.")]) : _vm._e(), _vm._v(" "), (_vm.passwordInvalid) ? _c('li', [_vm._v("Boekings nummer is verkeerd.")]) : _vm._e(), _vm._v(" "), (_vm.combinationInvalid) ? _c('li', [_vm._v("Email + boekings nummer combinatie is verkeerd.")]) : _vm._e(), _vm._v(" "), (_vm.connectionError) ? _c('li', [_vm._v("Er is iets fout gegaan.")]) : _vm._e(), _vm._v(" "), (_vm.userAuth.tokenExpired) ? _c('li', [_vm._v("Sessie is verlopen. log opniew in om verder the gaan.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "md-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    class: {
      invalid: _vm.usernameInvalid
    },
    attrs: {
      "type": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', [_vm._v("E-mail")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "md-form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: {
      invalid: _vm.passwordInvalid
    },
    attrs: {
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "bar"
  }), _vm._v(" "), _c('label', [_vm._v("Reserveringsnummer")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "md-btn pull-right",
    on: {
      "click": _vm.submitUser
    }
  }, [_vm._v("Inloggen")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text-login"
  }, [(_vm.entity.name == 'amigo') ? _c('img', {
    attrs: {
      "src": require("../assets/text/amigo.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'amicitia') ? _c('img', {
    attrs: {
      "src": require("../assets/text/amicitia.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'hannick') ? _c('img', {
    attrs: {
      "src": require("../assets/text/hannick.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.entity.name == 'aircruise') ? _c('img', {
    attrs: {
      "src": require("../assets/text/aircruise.png"),
      "alt": ""
    }
  }) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-head"
  }, [_c('h3', [_vm._v("Log in")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53ee418d"}!./src/templates/login.html
// module id = 540
// module chunks = 1